import { Dtos, IncomeStatementId, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { financialPeriodsQueryKey, incomeStatementsQueryKey } from "../../financials";

export function useAdminUpdateIncomeStatementPeriod(accountId: SuretyAccountId) {
	const { patch } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: ({
			incomeStatementId,
			body,
		}: {
			incomeStatementId: IncomeStatementId;
			body: Dtos.Admin.IncomeStatement.UpdatePeriod.Request;
		}) =>
			patch<Dtos.Admin.IncomeStatement.UpdatePeriod.Response>(
				`/v2/admin/surety/accounts/${accountId}/income-statements/${incomeStatementId}/period`,
				body,
			),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: incomeStatementsQueryKey(accountId) });
			queryClient.invalidateQueries({ queryKey: financialPeriodsQueryKey(accountId) });
		},
	});

	return {
		updateIncomeStatementPeriod: mutation.mutate,
		updateISPeriodLoading: mutation.isPending,
		updateISPeriodError: mutation.error,
		resetUpdateISPeriodError: mutation.reset,
	};
}
